import { React, useState, useEffect } from 'react'
import "./header.css"
import { useNavigate } from 'react-router-dom';
import { connect, useDispatch } from "react-redux"
import Select from "react-select";
import { Link } from 'react-router-dom';
import { logout } from '../../../Redux/actions';
import { useSelector } from 'react-redux';
import { getProfile, getName, getCompany, getUserName } from '../../../Redux/selecters';
import Avatar from "../../Assets/images/avatar.png"
import { clearCompanies, updateCompany, updateSelectedCompany } from '../../../Redux/actions/companiesAction';
import ApiServiceInv from "../../services/apiService";
import { saveLogin, setUserRole } from "../../../Redux/actions";
import userManagement from "../../../POS/services/userManagement";
import { setCompanies } from "../../../Redux/actions/companiesAction";
import { toast } from 'react-toastify';

const Header = ({ Currency }) => {
    const dispatch = useDispatch()
    const user = useSelector((state) => state.auth);
    let navigate = useNavigate();
    const fulname = useSelector(getName);
    const [userName, setUsername] = useState(fulname)
    const Name = useSelector(getUserName);
    const companies = useSelector(getCompany);
    const apiService = new ApiServiceInv();
    const image = useSelector(getProfile);
    const [selectedCompany, setSelectedCompany] = useState([]);
    const [credentials, setCredentials] = useState({
        username: '',
        password: '',
        db: '',
        baseDb: ''
    });
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to toggle dropdown visibility

    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev); // Toggle dropdown state
    };

    const closeDropdown = () => {
        setIsDropdownOpen(false); // Close dropdown
    };

    useEffect(() => {
        // Close dropdown when clicking outside
        const handleOutsideClick = (event) => {
            if (!event.target.closest('.InvProfile')) {
                closeDropdown();
            }
        };
        document.addEventListener('click', handleOutsideClick);
        return () => document.removeEventListener('click', handleOutsideClick);
    }, []);
    useEffect(() => {
        const url = window.location.href;
        const regex = /_username=([^&]+)&_password=([^&]+)&_db=([^&]+)&_baseDb=([^&]+)/;
        const match = url?.match(regex);

        if (match) {
            handleLogin({
                username: match[1],
                password: match[2],
                db: match[3],
                baseDb: match[4]
            })
        }
    }, []);
    useEffect(() => {
        if (!userName) {
            dispatch(clearCompanies());
            // handleOut();
        }
    }, [userName]);
    const handleLogin = async (first) => {

        dispatch(logout());
        dispatch(clearCompanies());
        localStorage.clear();

        let token = localStorage.getItem("Token")
        if (!token) {
            let body = {
                email: credentials?.username || first?.username,
                password: credentials?.password || first?.password,
                basedb: credentials?.baseDb || first?.baseDb,
                supportdb: credentials?.db || first?.db
            };

            try {

                const response = await apiService.post("GET_ENCRYPT_TOKEN", body);

                setUsername(response?.data?.data?.fullName)
                if (response && response.status === 200) {
                    localStorage.setItem('Token', response?.data?.data?.accessToken)
                    dispatch(saveLogin(response?.data))
                    const userId = userManagement.getUserId(response?.data?.data?.userCompanies);
                    const InvUserId = userManagement?.getUserId2(response?.data?.data?.accessToken);
                    const userRole = userManagement.getUserRole(response?.data?.data?.accessToken);
                    dispatch(setUserRole(userRole))
                    localStorage.setItem('Refresh_Token', response?.data?.data?.refreshToken)
                    const userCompanies = response?.data?.data?.userCompanies;
                    dispatch(setCompanies(userCompanies));
                    localStorage.setItem('UserCompanies', JSON.stringify(userCompanies));

                    let selectedCompany = userCompanies.filter((comp) => comp.dataDB === response?.data?.data?.dataDb)
                    if (selectedCompany?.length === 1) {
                        dispatch(updateSelectedCompany(selectedCompany[0]));
                        setSelectedCompany({ label: selectedCompany[0]?.companyName, value: selectedCompany[0] });
                        localStorage.setItem('DataBase', selectedCompany[0]?.dataDB);
                        let param = `?username=${response?.data?.data?.userName}&companyNo=${selectedCompany[0]?.companyNo}`;
                        const res = await apiService.getApiParamater('GET_PERMISSIONS', param);
                        const permissions = res?.data?.data.filter((per) => per.moduleName === 'Procurement');
                        localStorage.setItem('RoleAccess', JSON.stringify(permissions));
                        // navigate("/")
                    } else if (selectedCompany?.length === 2) {
                        dispatch(updateSelectedCompany(selectedCompany[1]));
                        setSelectedCompany({ label: selectedCompany[1]?.companyName, value: selectedCompany[1] });
                        localStorage.setItem('DataBase', selectedCompany[1]?.dataDB);
                        let param = `?username=${response?.data?.data?.userName}&companyNo=${selectedCompany[1]?.companyNo}`;
                        const res = await apiService.getApiParamater('GET_PERMISSIONS', param);
                        const permissions = res?.data?.data.filter((per) => per.moduleName === 'Procurement');
                        localStorage.setItem('RoleAccess', JSON.stringify(permissions));
                        // navigate("/")
                    }

                    const curres = await apiService.get("GET_CURRENCY_PER");

                    console.log("API Currency Response:", curres?.data); // DEBUG
                    let data = curres?.data?.result;
                    localStorage.setItem('currencylist', JSON.stringify(data));
                    window.location.replace(`${window.location.origin}/`);
                    // window.location.reload();
                } else if (response.status == false) {
                    localStorage.clear();
                    // window.location.href = 'http://appflutter.kingfisher.com/';
                    window.location.href = 'https://pro360.freemyip.com/';
                }
            } catch (error) {
                console.log(error, "error");
                toast.error(error.response.data.data)
            }
        }

    };
    useEffect(() => {
        if (companies?.companies?.length) {
            let DB = localStorage.getItem('DataBase')
            let selectCompany = companies?.companies.filter((comp) => comp.dataDB === DB)

            if (selectCompany?.length === 1) {
                dispatch(updateSelectedCompany(selectCompany[0]));
                setSelectedCompany({ label: selectCompany[0]?.companyName, value: selectCompany[0] });
                localStorage.setItem('DataBase', selectCompany[0]?.dataDB);
            } else if (selectCompany?.length === 2) {
                dispatch(updateSelectedCompany(selectCompany[1]));
                setSelectedCompany({ label: selectCompany[1]?.companyName, value: selectCompany[1] });
                localStorage.setItem('DataBase', selectCompany[1]?.dataDB);
            }
        }
    }, [companies?.companies, dispatch]);

    const handleDBChange = async (selectedOption) => {
        setSelectedCompany(selectedOption);
        dispatch(updateCompany(0, selectedOption.value));
        localStorage.setItem('DataBase', selectedOption?.value?.dataDB);
        let param = `?username=${Name}&companyNo=${selectedOption?.value?.companyNo}`

        const res = await apiService.getApiParamater("GET_PERMISSIONS", param);

        const permissions = res?.data?.data.filter((per) => per.moduleName === "Procurement");
        localStorage.setItem('RoleAccess', JSON.stringify(permissions));
        window.location.reload();
    };

    const handleOut = () => {
        dispatch(logout());
        dispatch(clearCompanies());
        localStorage.clear();
        // window.location.href = 'http://appflutter.kingfisher.com/';
        window.location.href = 'https://app.pro360erp.com/';
    };
    const UserName = userName?.length > 20 ? userName.substring(0, 10) + '...' : userName;
    const DocFilter = [
        { value: '----', label: 'From 01 Jan,2024 To 31 Dec,2024' },
        { value: 'Youusuf LLC', label: 'From 01 Jan,2023 To 31 Dec,2023' },
        { value: 'Z PSRED test', label: 'From 01 Jan,2022 To 31 Dec,2022' },
    ];
    return (
        <nav class="navbar-expand-lg  invHead ">
            <div class="container-fluid">
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse d-flex end gap-4" id="navbarSupportedContent">
                    <div className="col-4 heading-title">Procurement</div>
                    <div className='col-3'></div>
                    <div className='end col-2'>
                        <Select
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 8,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            className="w-75 p-0"
                            onChange={handleDBChange}
                            value={selectedCompany} isDisabled
                        // options={companies?.companies?.map(comp => ({ value: comp, label: comp?.companyName }))}
                        />
                    </div>
                    <div className="d-flex gap-2">
                        <div className="invprofileimg">
                            {image ? (
                                <img src={image || Avatar} className="Invboxicon" alt="Profile" />
                            ) : (
                                <img src={Avatar} className="Invboxicon" alt="Avatar" />
                            )}
                        </div>
                        <div className="InvProfile dropdown">
                            <div onClick={toggleDropdown} className="dropdown-toggle">
                                {userName || "No-User"}
                            </div>
                            {isDropdownOpen && (
                                <div className="dropdown-content-stats pt-1">
                                    <Link to="/admin/Setting/Profile" className="p-2">Setting</Link>
                                    <Link onClick={handleOut} className="p-2">Log Out</Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    )
}

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(Header);
